/**
 * Load runtime config from /config.json (served by nginx from mounted ConfigMap).
 * Keeps each admin deployment pointed at its matching backend environment.
 * Format: { "apiBaseUrl": "https://dev.chargex.am", "techWebUrl": "https://tech.dev.chargex.am" }
 */
const CONFIG_URL = '/config.json';
const TIMEOUT_MS = 3000;

let cachedConfig = null;

export function getRuntimeConfig() {
  return cachedConfig;
}

export function getTechWebUrl() {
  return process.env.REACT_APP_TECH_WEB_URL || cachedConfig?.techWebUrl || '';
}

export function loadRuntimeConfig() {
  return new Promise((resolve) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), TIMEOUT_MS);
    fetch(CONFIG_URL, { cache: 'no-store', signal: controller.signal })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        clearTimeout(timeout);
        cachedConfig = data && typeof data === 'object' ? data : null;
        resolve(cachedConfig);
      })
      .catch(() => {
        clearTimeout(timeout);
        cachedConfig = null;
        resolve(null);
      });
  });
}
